(ns quuppa.qsm.api-keys.view
  (:require [linked.core :as l]
            ["react" :as react]
            [re-frame.core :as rf]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.tables :as tables]
            [quuppa.qsm.api-keys.events :as e]
            quuppa.qsm.api-keys.subs
            [quuppa.qsm.cors.view :as cors]
            [quuppa.routing :refer [use-subscriptions]]
            [quuppa.ui.layout :as layout]))

(defn new-api-key-form [{:keys [qpe-subscribe qpe-dispatch]}]
  (let [{:keys [key-name] :as form} @(qpe-subscribe [:qpe/data :ui :sidebar :form])
        new-api-key @(qpe-subscribe [:qpe/data :ui :sidebar :new-api-key])
        error @(qpe-subscribe [:qpe/data :ui :sidebar :error])]
    [layout/sidebar
     [layout/sidebar-header
      {:on-close #(qpe-dispatch [:qpe/close-sidebar])
       :title "Create API token"}]

     [layout/sidebar-content
      [:p "Create an access token for QSM API"]

      (let [e (-> error :ex-data :malli-error :key-name first)]
        [:div.form-group
         [:label "Name:"]
         [:input.form-control
          {:value key-name
           :read-only (some? new-api-key)
           :on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :form :key-name] (.. % -target -value)])
           :class [(when e "is-invalid")]}]
         (when e
           [:p.form-text.text-danger e])])

      (when-not (some? new-api-key)
        [:button.btn.btn-primary
         {:on-click #(qpe-dispatch [:qsm/generate-api-key form])}
         "Generate"])

      (when (-> error :ex-data :malli-error (dissoc :key-name) seq)
        [:div.alert.alert-danger
         [c/error-alert error]])

      (when new-api-key
        [:div.border.p-4
         [:span "API token:"]
         [c/copy-text-input
          {:value (:secret-key new-api-key)}
          "Copy"]
         [:p "For security reasons the API token is shown only once."]
         [:p "Copy and save it before closing this panel."]
         [:button.btn.btn-primary
          {:on-click #(qpe-dispatch [:qpe/close-sidebar])}
          "Close"]])]]))

(def api-columns
  (l/map
    :key-name
    {:value-fn :key-name
     :sortable true
     :width "20%"
     :label "Key name"}

    :created-at
    {:value-fn :created-at
     :sortable true
     :width "15%"
     :label "Created at"}

    :created-by
    {:value-fn :created-by
     :sortable true
     :width "15%"
     :label "Created by"}

    :last-used-at
    {:value-fn :last-used-at
     :sortable true
     :width "25%"
     :label "Last used at"}

    :revoke-column
    {:value-fn :revoke-column
     :sortable false
     :width "10%"
     :label "Actions"}))

(rf/reg-sub
  ::sorted-api-keys
  (fn [_ [_ api-keys sort-key sort-order]]
    (let [column (get api-columns sort-key)]
      (sort-by (:value-fn column)
               (if sort-order compare #(compare %2 %1))
               api-keys))))

(defn api-keys-view [{:keys [qpe-identity qpe-subscribe qpe-dispatch] :as opts} owner-or-admin?]
  (let [[sort-key set-sort-key] (react/useState :key-name)
        [sort-order-asc set-sort-order-asc] (react/useState false)

        sidebar-type @(qpe-subscribe [:qpe/data :ui :sidebar :type])
        {api-keys :result} @(q/subscribe e/api-keys-query {:qpe-identity qpe-identity})
        sorted-api-keys @(rf/subscribe [::sorted-api-keys api-keys sort-key sort-order-asc])]
    (react/useEffect (fn []
                       (q/execute e/api-keys-query {:qpe-identity qpe-identity})
                       (fn []))
                     #js [qpe-identity])
    (use-subscriptions (when qpe-identity
                         [[:api-keys/add {:qpe-identity qpe-identity}]
                          [:api-keys/remove {:qpe-identity qpe-identity}]])
                       #js [qpe-identity])
    [layout/section
     [layout/view-content
      {:sidebar-open sidebar-type}
      [layout/view-header
       {:title "Active API tokens"
        :actions (when owner-or-admin?
                   [:button.btn.btn-primary
                    {:on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar] {:type :new-api-key}])}
                    "Create API token"])}]

      [:table.table.table-striped.table-bordered
       [tables/thead
        {:columns api-columns
         :sort-key sort-key
         :sort-order-asc sort-order-asc
         :toggle-sort-order (fn [] (set-sort-order-asc not))
         :set-sort-key (fn [k]
                         (set-sort-key k)
                         (set-sort-order-asc true))}]
       [:tbody
        (for [api-key sorted-api-keys]
          ^{:key (:id api-key)}
          [:tr
           [:td (:key-name api-key)]
           [:td (date-time/format-instant (:created-at api-key))]
           [:td (:created-by api-key)]
           [:td (date-time/format-instant (:last-used-at api-key))]
           [:td.text-right
            (when owner-or-admin?
              [:button.btn.btn-primary
               {:on-click (fn [_e]
                            (when (js/confirm "Are you sure?")
                              (qpe-dispatch [:qsm/revoke-api-key (:id api-key)])))}
               "Revoke"])]])]]

      [:f> cors/view opts owner-or-admin?]]

     (case sidebar-type
       :new-api-key [new-api-key-form opts]
       :new-origin [cors/new-origin opts]
       nil)]))

(def controller
  {:id :api-keys
   :parameters {:path [:qpe-identity]}})
